import { render, staticRenderFns } from "./coupon-edit.vue?vue&type=template&id=641ad33d&scoped=true&"
import script from "./coupon-edit.vue?vue&type=script&lang=js&"
export * from "./coupon-edit.vue?vue&type=script&lang=js&"
import style0 from "./coupon-edit.vue?vue&type=style&index=0&id=641ad33d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641ad33d",
  null
  
)

export default component.exports